import { Link } from "react-router-dom";
import BgShape from "../images/hero/hero-bg1.jpg";
import HeroCar from "../images/hero/main-car.gif";
import { useEffect, useState } from "react";
import whatsapp from "../images/logo/whatsapp.png";
import facebook from "../images/logo/fb.png";


function Hero() {
  const [goUp, setGoUp] = useState(false);
  //const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const bookBtn = () => {
    document.querySelector('#booking-section').scrollIntoView({ behavior: 'smooth' });
  };

  const bookBtn2 = () => {
    document.querySelector('#booking-section2').scrollIntoView({ behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/264816464376', '_blank');   
  };

  const openfacebook = () => {
    window.open('https://www.facebook.com/p/CE-CAR-Rental-100046570886985/', '_blank'); 
   };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.pageYOffset > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('scroll', onPageScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', onPageScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const styles = {
    btn: {
      backgroundColor: '#9f5e37',
      backgroundImage: 'linear-gradient(105deg, #9f5e37 0%, #3d281a 100%)', 
      transition: 'box-shadow 0.3s ease-in-out',
      fontSize: '18px',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px 20px',
      margin: '5px', // add margin for spacing between buttons
      borderColor:'brown',
      borderRadius: '8px',
    },
  };


  const [slideIn, setSlideIn] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Trigger the slide-in animation after a short delay
    const delay = setTimeout(() => {
      setSlideIn(true);
    }, 850); // Adjust the delay as needed

    // Clear the timeout on component unmount to avoid memory leaks
    return () => clearTimeout(delay);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const slideAnimation = {
    zIndex: 2,
    position: 'absolute',
    right: slideIn ? 40 : '-100%',
    transition: 'right 2.0s ease-in-out',
    width: '100%', // Set the maximum width to 100%
    height: 'auto', // Maintain the aspect ratio
    maxWidth: windowWidth < 768 ? '80%' : '55%', // Set maxWidth for mobile view
    marginTop: '2rem',
  };
  



  const containerStyle = {
    position: 'relative', height:'730px', marginTop:'-45px',
    //backgroundImage: 'linear-gradient(315deg, #00690a 0%, #3a9e0e 74%)',
    // Adjusted the color values to create a darker gradient
    // Add any other styles you need here
  };

  const bgImageStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
   //aspectRatio: '2/1'
  };



  return (

    <section id="home" className="banner-section" style={containerStyle}>
      
      <div className="container" >
      <img src={BgShape} alt="Background Shape" style={bgImageStyle} />
      <div className="hero-content" style={{ position: 'relative', zIndex: 2, height:'350px', marginTop:'14.5rem' }}>
        <div className="hero-content__text">
          

          <h1 style ={{backgroundColor: 'rgba(255, 255, 255, 0.3)', marginTop:'39px', fontSize:'44px'}}>
        A Hustle Free Affordable Option
          </h1>
          <div style={{ height: '110px', width:'95%' }}>
            {windowWidth >= 1100 ? (
              <div style={styles.container}>
                <p style={{ color:'black' ,backgroundColor: 'rgba(255, 255, 255, 0.6)', borderRadius:'25px'}}>
                Experience the car of your dreams with CE Car Rental. Enjoy unparalleled prices, unlimited mileage.
                </p>
              </div>
            ) : null}
          </div>
          <div className="hero-content__text__btns">
            <Link onClick={bookBtn} className="hero-content__text__btns__book-ride" to="/" style={styles.btn}>
              Book Car
            </Link>
            <a
              style={styles.btn}
            href="https://maps.app.goo.gl/DkKQv8ym1MxbakPb6"
              target="_blank"
              rel="noopener noreferrer"
              className="hero-content__text__btns__book-ride"
            >
              Location
            </a>
            <Link onClick={bookBtn2} className="hero-content__text__btns__book-ride" to="/" style={styles.btn}>
              Book Camper
            </Link>
          </div>
        </div>

    {/*    <img src={HeroCar} alt="car-img" style={slideAnimation} /> */} 

      </div>

    </div>

      {/* WhatsApp button */}


      <div
        onClick={openWhatsApp}
        className="whatsapp-btn"
        style={{
          position: 'fixed',
          bottom: '130px',
          left: '1rem',
          zIndex: '1000',
        }}
      >
        <img src={whatsapp} alt="Whatsapp-img" style={{ height: 60, width: 60 }} />
      </div>

      <div
        onClick={openfacebook}
        className="whatsapp-btn"
        style={{
          position: 'fixed',
          bottom: '45px',
          left: '1rem',
          zIndex: '1000',
        }}
      >
        <img src={facebook} alt="Whatsapp-img" style={{ height: 60, width: 60 }} />
      </div>


      {/* Scroll to top button */}
      <div style={{   backgroundColor: '#9f5e37',
      backgroundImage: 'linear-gradient(105deg, #9f5e37 0%, #3d281a 100%)', }} onClick={scrollToTop} className={`scroll-up ${goUp ? 'show-scroll' : ''}`}>
        <p style={{ fontSize: 22 }}>&#9650;</p>
      </div>
    </section>
  );
}

export default Hero;

const styles = {
  container: {
   // height: '110px',
    display: 'block', // Ensure it's a block element
   
  },
  // Media query to hide the container when the screen width is less than 500px
  '@media (max-width: 800px)': {
    container: {
      display: 'none',
      
    },
  },
};